export default "__VITE_ASSET__7c1252cc__"